import { List, Record } from 'immutable'

import ActionTypes from '../constants/action-types'
import LeaveType from '../model/leaveType'
import { ReducerAction } from '../utils/reducer-utils'

export interface LeaveTypeReducer {
  companyID: string | undefined // keeping track of the active company by listening on COMPANY_SETTING_ACTIVE
  loading: boolean
  loaded: boolean
  saving: boolean
  leaveTypes: List<LeaveType>
  error: Error | null
}

const Params = Record<LeaveTypeReducer>({
  companyID: undefined, // keeping track of the active company by listening on COMPANY_SETTING_ACTIVE
  loading: false,
  loaded: false,
  saving: false,
  leaveTypes: List<LeaveType>(),
  error: null,
})

export interface LeaveTypeAction extends ReducerAction {
  companyID?: string
  leaveTypes?: LeaveType[]
  leaveType?: LeaveType
}

export default (
  state: Record<LeaveTypeReducer> = Params(),
  action: LeaveTypeAction = { type: '' }
): Record<LeaveTypeReducer> => {
  // keep track of the active company
  if (action.type === ActionTypes.COMPANIES_SETTING_ACTIVE || action.type === ActionTypes.COMPANIES_LOADED) {
    return Params({
      companyID: action.companyID,
    })
  }
  // only process actions for the active company
  if ('companyID' in action && action.companyID !== state.get('companyID')) {
    return state
  }

  let idx = -1
  switch (action.type) {
    case ActionTypes.LEAVE_TYPES_LOADING:
      return Params({
        companyID: state.get('companyID'),
        loading: true,
      })
    case ActionTypes.LEAVE_TYPES_LOADED:
      return Params({
        companyID: state.get('companyID'),
        loaded: true,
        leaveTypes: List<LeaveType>(action.leaveTypes),
      })
    case ActionTypes.LEAVE_TYPES_LOAD_FAILED:
      return Params({
        companyID: state.get('companyID'),
        error: action.error,
      })

    case ActionTypes.LEAVE_TYPES_UPDATING:
      return state.set('saving', true)
    case ActionTypes.LEAVE_TYPES_UPDATED:
      if (!action.leaveType) {
        return state
      }
      idx = state.get('leaveTypes').findIndex((type) => !!action.leaveType && type.id === action.leaveType.id)
      if (idx === -1) {
        return state.set('saving', false)
      }
      return state.set('saving', false).set('leaveTypes', state.get('leaveTypes').set(idx, action.leaveType))
    case ActionTypes.LEAVE_TYPES_UPDATE_FAILED:
      return state.set('saving', false).set('error', action.error || null)

    case ActionTypes.USER_LOGGED_OUT:
      return Params()
    default:
      return state
  }
}
